import { Button } from 'reactstrap';
import Modal from '../../basics/Modal';
import {
  LandAdvisorModalBody,
  LandAdvisorModalFooter,
} from './LandAdvisorModal';

const ImportMessagesModal = ({
  messages,
  setMessages,
  isOpen,
  setIsOpen,
}: {
  messages: {
    info?: string;
    warnings?: string[];
    errors?: string[];
  };
  setMessages: (messages: {
    info?: string;
    warnings?: string[];
    errors?: string[];
  }) => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  const closeMessageModal = () => {
    setMessages({});
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={closeMessageModal} centered scrollable>
      <LandAdvisorModalBody>
        {messages.info && <div className="info">{messages.info}</div>}
        {!!messages.warnings?.length && (
          <>
            <div className="warning-label">Warnings</div>
            {messages.warnings.map((warning, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={i} className="warning">
                {warning}
              </div>
            ))}
          </>
        )}
        {!!messages.errors?.length && (
          <>
            <div className="error-label">Errors</div>
            {messages.errors.map((error, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={i} className="error">
                {error}
              </div>
            ))}
          </>
        )}
      </LandAdvisorModalBody>
      <LandAdvisorModalFooter>
        <Button color="primary" onClick={closeMessageModal} size="sm">
          OK
        </Button>
      </LandAdvisorModalFooter>
    </Modal>
  );
};

export default ImportMessagesModal;
